module.exports = __webpack_public_path__ + "media/Video (27).1590547b.mp4";